/* ZOOPLICITY Pomaga - storefront connector. Disabled in Theme Editor by default.
   Requires live Help Engine Shopify App Proxy: /apps/zooplicity-pomaga?view=partners
   Never trusts browser-side cart attributes as an authorization or payment instruction. */
(() => {
  'use strict';
  const PROXY = '/apps/zooplicity-pomaga?view=partners';
  const ATTR = 'zooplicity_help_partner';
  const POOL = 'shared_pool';
  const rootPath = () => window.Shopify?.routes?.root || '/';
  let partnersPromise;

  function safeHttpUrl(raw) {
    if (typeof raw !== 'string') return null;
    try {
      const url = new URL(raw);
      return url.protocol === 'https:' ? url.href : null;
    } catch { return null; }
  }

  function fetchPartners() {
    if (!partnersPromise) {
      partnersPromise = fetch(PROXY, { credentials: 'same-origin', cache: 'no-store', headers: {Accept:'application/json'} })
        .then((res) => { if (!res.ok) throw Error('App Proxy: ' + res.status); return res.json(); })
        .then((data) => {
          if (!data || !Array.isArray(data.partners)) throw Error('Invalid partners response');
          return data.partners.filter((partner) => partner && typeof partner.id === 'string' &&
            partner.id !== POOL && partner.id.length <= 128 && typeof partner.name === 'string' && partner.name.trim());
        })
        .catch((error) => { partnersPromise = null; throw error; });
    }
    return partnersPromise;
  }

  async function readCart() {
    const res = await fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers:{Accept:'application/json'} });
    if (!res.ok) throw Error('Cart unavailable');
    return res.json();
  }

  function status(root, message) {
    const node = root.querySelector('[data-zp-help-choice-status]');
    if (node) node.textContent = message;
  }
  async function initChoice(root) {
    if (root.dataset.helpInit === 'yes') return;
    root.dataset.helpInit = 'yes';
    const select = root.querySelector('[data-zp-help-choice-select]');
    if (!select) return;
    try {
      const partners = await fetchPartners();
      if (!root.isConnected) return;
      select.replaceChildren();
      const placeholder = new Option('Wybierz schronisko lub Wspólną Pulę', '');
      placeholder.disabled = true;
      placeholder.hidden = true;
      select.add(placeholder);
      select.add(new Option('Wspólna Pula', POOL));
      partners.forEach((partner) => select.add(new Option(partner.name, partner.id)));
      const cart = await readCart();
      const current = typeof cart?.attributes?.[ATTR] === 'string' ? cart.attributes[ATTR] : '';
      select.value = Array.from(select.options).some((option) => option.value === current) ? current : '';
      root.dataset.saved = select.value;
      status(root, current
        ? 'Zapisany wybór obowiązuje dla tego zamówienia. Nie dopłacasz za pomoc.'
        : 'Wybierz schronisko lub Wspólną Pulę.');
      select.disabled = false;
    } catch {
      status(root, 'Wybór schroniska jest teraz niedostępny. Zakupy działają normalnie; pomoc rozliczymy według zasad programu.');
      select.disabled = true;
      root.dataset.helpInit = 'no';
      return;
    }
    select.addEventListener('change', async () => {
      const selected = select.value;
      if (!selected) { select.value = root.dataset.saved || ''; return; }
      const valid = Array.from(select.options).some((option) => option.value === selected);
      if (!valid) return;
      select.disabled = true;
      status(root, 'Zapisujemy wybór…');
      try {
        const res = await fetch(rootPath() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type':'application/json', Accept:'application/json' },
          body: JSON.stringify({ attributes: { [ATTR]: selected } })
        });
        if (!res.ok) throw Error('Cart update failed');
        const cart = await res.json();
        if (cart?.attributes?.[ATTR] !== selected) throw Error('Cart attribute not saved');
        root.dataset.saved = selected;
        status(root, 'Zapisano wybór dla tego koszyka.');
      } catch {
        select.value = root.dataset.saved || '';
        status(root, 'Nie udało się zapisać wyboru. Spróbuj ponownie.');
      } finally { select.disabled = false; }
    });
  }

  function partnerCard(partner) {
    const article = document.createElement('article');
    article.className = 'zp-help-partner';
    article.dataset.zpHelpEnginePartner = 'yes';
    const visual = document.createElement('div');
    visual.className = 'zp-help-partner__visual';
    const logo = safeHttpUrl(partner.logoUrl);
    if (logo) {
      const img = document.createElement('img');
      img.className = 'zp-help-partner__image';
      img.src = logo; img.alt = partner.name; img.loading = 'lazy';
      visual.append(img);
    } else {
      const placeholder = document.createElement('div');
      placeholder.className = 'zp-help-partner__placeholder';
      placeholder.textContent = '♡'; placeholder.setAttribute('aria-hidden', 'true');
      visual.append(placeholder);
    }
    const body = document.createElement('div');
    body.className = 'zp-help-partner__body';
    const heading = document.createElement('h3'); heading.textContent = partner.name;
    body.append(heading);
    if (typeof partner.publicDescription === 'string' && partner.publicDescription.trim()) {
      const description = document.createElement('p'); description.textContent = partner.publicDescription;
      body.append(description);
    }
    const website = safeHttpUrl(partner.websiteUrl);
    if (website) {
      const link = document.createElement('a');
      link.href = website; link.rel = 'noopener noreferrer'; link.target = '_blank';
      link.textContent = 'Poznaj schronisko →'; body.append(link);
    }
    article.append(visual, body);
    return article;
  }

  async function initPartnerSection(section) {
    if (section.dataset.zpHelpPartnersDynamic !== 'true' || section.dataset.helpInit === 'yes') return;
    section.dataset.helpInit = 'yes';
    const grid = section.querySelector('[data-zooplicity-help-partners]');
    if (!grid) return;
    try {
      const partners = await fetchPartners();
      if (!section.isConnected) return;
      const nodes = partners.map(partnerCard);
      if (!nodes.length) {
        const empty = document.createElement('div');
        empty.className = 'zp-help-partners__empty';
        empty.textContent = 'Partnerów programu opublikujemy po potwierdzeniu współpracy.';
        nodes.push(empty);
      } else {
        const more = grid.querySelector('.zp-help-partner--more');
        if (more) nodes.push(more);
      }
      grid.replaceChildren(...nodes);
    } catch {
      // Never replace existing Theme Editor partner blocks on an API failure.
      section.dataset.helpInit = 'no';
    }
  }

  function init() {
    document.querySelectorAll('[data-zp-help-choice]').forEach(initChoice);
    document.querySelectorAll('[data-zp-help-partners-dynamic]').forEach(initPartnerSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:updated', init);
  document.addEventListener('cart:update', init);
})();
